import { render, staticRenderFns } from "./students-chat.vue?vue&type=template&id=0600fec0&scoped=true"
import script from "./students-chat.vue?vue&type=script&lang=js"
export * from "./students-chat.vue?vue&type=script&lang=js"
import style0 from "./students-chat.vue?vue&type=style&index=0&id=0600fec0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0600fec0",
  null
  
)

export default component.exports